const brands = [
    "Audi",
    "Mercedes",
    "Bmw",
    "Ford",
    "Tesla",
    "Volvo"
]
export default brands;